(function ($) {
  "use strict";
  $(function () {
    function showTab(n) {
      const x = $(".tab");
      x[n].style.display = "block";
    }

    function validateForm(n) {
      let isChecked = true;
      if (
        $(".tab")
          .eq(n)
          .find(".question-row").length
      ) {
        const y = $(".tab")
          .eq(n)
          .find("input[type=radio]");
        if (y.length) {
          isChecked = false;
          for (let i = 0; i < y.length; i += 1) {
            if (y[i].checked) {
              isChecked = true;
              break;
            }
          }
        }
      }
      return isChecked;
    }

    function resetQuizForm() {
      $(".quiz-form").trigger("reset");
    }

    if ($(".quiz-section").length) {
      let currentTab = 0;
      showTab(currentTab);

      $(".quiz-next-btn").on("click", e => {
        e.preventDefault();

        if (!validateForm(currentTab)) {
          swal({
            title: "Hiba történt!",
            text: "Nem választottál ki semmit",
            icon: "error",
            button: "Vissza"
          });
          return false;
        }

        const x = $(".tab");

        x[currentTab].style.display = "none";

        currentTab += 1;
        if (currentTab >= x.length) {
          currentTab = 0;
          showTab(currentTab);
        } else {
          showTab(currentTab);
        }
      });

      $(".quiz-form").on("submit", function (e) {
        e.preventDefault();
        const $this = $(this);

        if (!validateForm(currentTab)) {
          swal({
            title: "Hiba történt!",
            text: "Nem választottál ki semmit",
            icon: "error",
            button: "Vissza"
          });
          return false;
        }

        $(this)
          .find(".quiz-submit-btn")
          .prop("disabled", true);
        const formdata = $this.serializeArray();
        $.ajax({
          url: ajax.ajaxurl,
          type: "POST",
          data: {
            action: "quiz_form",
            datas: formdata
          }
        }).done(response => {
          $this.find(".quiz-submit-btn").prop("disabled", false);
          resetQuizForm();
          const x = $(".tab");
          x[currentTab].style.display = "none";
          currentTab += 1;
          showTab(currentTab);
        });
      });
    }
  });
})(jQuery);
